import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_ORDER = "listOrder";
export const GET_DETAIL_ORDER = "detailOrder";
export const SAVE_ORDER = "saveOrder";
export const UPDATE_ORDER = "updateOrder";
export const DELETE_ORDER = "deleteOrder";
// export const UPLOAD_ORDER = "/upload/tags";


export const SET_LIST_ORDER = "setListOrder";
export const SET_DETAIL_ORDER = "setDetailOrder";

export const SET_LIST_ORDER_SEARCH = "setListOrderSearch";
export const GET_LIST_ORDER_SEARCH = "getListOrderSearch";



const state = {
    orders: [],
    order: {},
    oderSearches : [],
    
};

const getters = {
    orders(state) {
        return state.orders;
    },
    orderDetail(state) {
        return state.order;
    },
    oderSearches(state) {
        return state.oderSearches;
    },
};

const actions = {
    [GET_LIST_ORDER](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ORDER).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_ORDER, data);
                    context.commit(SET_LIST_ORDER_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_ORDER_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ORDER_SEARCH, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_ORDER_SEARCH, data.data.orders);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_ORDER](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_ORDER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_ORDER, data);
                }
                resolve(data);
            });
        });
    },
    // [UPLOAD_ORDER](context, payload) {
    //     return new Promise((resolve, reject) => {
    //         ApiService.post(API.UPLOAD_ORDER_IMAGE, payload)
    //             .then((data) => {
    //                 resolve(data)
    //             })
    //             .catch((err) => {
    //                 console.log(err)
    //                 reject(err);
    //             });
    //     });
    // },
    [SAVE_ORDER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_ORDER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_ORDER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_ORDER}`,payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_ORDER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_ORDER}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_ORDER](state, data) {
        state.orders = data.data;
    },
    [SET_DETAIL_ORDER](state, data) {
        state.order = data.data;
    }
    ,
    [SET_LIST_ORDER_SEARCH](state, data) {
        state.oderSearches = data;
    }

    
};

export default {
    state,
    actions,
    mutations,
    getters
};
